import React from "react";
import { Box, Grid } from "@mui/material";
import MessageItem from "./MessageItem";

const MessageList = ({
  messages,
  onChangeMessageButtons,
  channel,
  disabledButtons,
  hideMediaConfigMenu,
  highlightIncomingMessage,
  onPickImage,
  onPickPdf,
  onReplaceMedia,
  onRemoveMedia,
  allowedButtonTypes,
}) => {
  const isWhatsappLayout =
    channel === "whatsapp_api" || channel === "whatsapp_web" || channel === "sms";

  return (
    <Box
      sx={{
        flex: 1,
        overflowY: "auto",
        px: isWhatsappLayout ? 1 : 2,
        py: isWhatsappLayout ? 0.5 : 1,

        scrollbarWidth: "thin",
        "&::-webkit-scrollbar": {
          width: "6px",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "#888",
          borderRadius: "3px",
        },
      }}
    >
      <Grid container spacing={isWhatsappLayout ? 1.25 : 2}>
        {messages.map((message) => (
          <MessageItem
            key={message.id}
            message={message}
            onChangeMessageButtons={onChangeMessageButtons}
            channel={channel}
            disabledButtons={disabledButtons}
            hideMediaConfigMenu={hideMediaConfigMenu}
            highlightIncomingMessage={highlightIncomingMessage}
            onPickImage={onPickImage}
            onPickPdf={onPickPdf}
            onReplaceMedia={onReplaceMedia}
            onRemoveMedia={onRemoveMedia}
            allowedButtonTypes={allowedButtonTypes}
          />
        ))}
      </Grid>
    </Box>
  );
};

export default MessageList;
